import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { getContents } from "../../actions/contents";
import { convertToSlug, dataUrl } from "../../helpers/common";
import moment from "moment";

const PopularPost = () => {
  const dispatch = useDispatch();
  const { blogId } = useParams();

  const blogs = useSelector((state) => state.contents["blogs"]);

  // ✅ Fix: Check if blogs.data is an array, then filter. Otherwise check blogs itself.
  const blogList = Array.isArray(blogs?.data) ? blogs.data : Array.isArray(blogs) ? blogs : [];
  
  const filteredPost = blogList?.filter((blog) => blog?.id !== parseInt(blogId));

  useEffect(() => {
    dispatch(getContents("blogs"));
  }, [dispatch]);

 return (
  <React.Fragment>
    <div className='pt-0'>
      <div className='sd-title'>
        <h6 className='fs-16 mb-3'>More Post</h6>
      </div>
      <ul className='widget-popular-post list-unstyled my-4'>
        {filteredPost?.map((blog, key) => (
          <li className='border-bottom mb-3' key={key}>
            <Link
              className='d-flex mb-3 align-items-center'
              to={`/blogs/${blog?.id}/${convertToSlug(blog?.name)}`}
            >
              <img
                /* ✅ API mein 'image' key hai aur wo full URL hai */
                src={blog?.image} 
                alt={blog?.name}
                className='widget-popular-post-img rounded'
                style={{ minWidth: 85, height: 60, objectFit: 'cover' }}
              />
              <div className='flex-grow-1 text-truncate ms-3'>
                <span className='text-dark'>{blog?.name}</span>
                <span className='d-block text-muted fs-14'>
                  {/* ✅ API mein 'createdAt' hai (camelCase) */}
                  {moment(blog?.createdAt).format("MMM DD, YYYY")}
                </span>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  </React.Fragment>
);
};

export default PopularPost;
